@import 'common/stylesheets/mixins/common.styl'

.tooltip-container
  pointer-events none
  z-index $z-tooltip
  &.card-mode
    z-index $z-report-editor-modal

  .tooltip
    background-color var(--inverted-component-background-color)
    border-color var(--inverted-component-background-color)
    border-radius 4px
    color var(--inverted-component-text-color)

    /* stylelint-disable-next-line stylus-modules/no-broad-descendant-selectors */
    a, .mp-link
      cursor pointer
      text-decoration none

      &, &:visited
        color var(--inverted-blue1)

      &:hover
        color var(--inverted-blue1)

    .tooltip-content
      border-radius 4px
      box-shadow $box-shadow
      cursor default
      font-family $family-helvetica
      font-size $font-size-small
      font-weight $weight-medium
      justify-content center
      letter-spacing normal
      line-height 14px
      padding 8px
      pointer-events auto
      position relative
      text-transform initial
      white-space pre
      set-all-box-sizing(border-box)

    .has-max-width
      overflow-wrap break-word
      white-space pre-wrap
